import { axiosInstance } from ".."

const generateOrderViaCustomOrder = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`internal/CustomOrder/createDraftorder/${id}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default generateOrderViaCustomOrder;